import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from 'investira.react.components';
function DrawerTemplate(props) {
  const {
    children,
    open,
    ...restProps
  } = props;
  const Component = children;
  return <Drawer anchor={'bottom'} open={open} {...restProps} fullHeight>
            {/* <ErrorBoundary> */}
            {Component ? <Component /> : null}
            {/* </ErrorBoundary> */}
        </Drawer>;
}
DrawerTemplate.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  child: PropTypes.elementType
};
DrawerTemplate.displayName = 'DrawerTemplate';
export default DrawerTemplate;
